import { NavLink } from 'react-router-dom';

import {
   CandidateSidebarAction,
   CandidateSidebarItem,
   CandidateSidebarSection,
} from './candidate-sidebar.types';

type CandidateSidebarSectionProps = {
   onActionClick: (action: CandidateSidebarAction) => void;
   section: CandidateSidebarSection;
   t: (key: string) => string;
};

const getNavLinkClassName = (baseClassName: string, isLoading: boolean) => {
   return ({ isActive }: { isActive: boolean }) =>
      `bodyItem ${baseClassName}${isActive ? ' Active' : ''}${isLoading ? ' is-loading' : ''}`;
};

export const CandidateSidebarSectionView = ({
   onActionClick,
   section,
   t,
}: CandidateSidebarSectionProps) => {
   const renderMenuItem = (item: CandidateSidebarItem) => {
      const isLoading = section.loadingItemId === item.id;
      const iconStyle = item.iconBackgroundSrc
         ? { backgroundImage: `url(${item.iconBackgroundSrc})` }
         : undefined;

      const menuItemInner = (
         <>
            <div className={`SidebarImages ${item.iconClassName}`} style={iconStyle}>
               <img src={item.iconSrc} alt="" />
            </div>
            <div className="menuTitle">{t(item.titleKey)}</div>
            {isLoading && <span className="candidate-sidebar-item-spinner" aria-hidden="true" />}
         </>
      );

      if (item.type === 'link') {
         return (
            <NavLink
               key={item.id}
               to={item.to}
               className={getNavLinkClassName(item.itemClassName, isLoading)}
               aria-busy={isLoading}
               onClick={(event) => {
                  item.canActivate?.({ event, item });
               }}
            >
               {menuItemInner}
            </NavLink>
         );
      }

      return (
         <NavLink
            key={item.id}
            to=""
            className={`bodyItem ${item.itemClassName}${isLoading ? ' is-loading' : ''}`}
            aria-busy={isLoading}
            onClick={(event) => {
               item.canActivate?.({ event, item });

               if (event.defaultPrevented) {
                  return;
               }

               event.preventDefault();
               onActionClick(item.action);
            }}
         >
            {menuItemInner}
         </NavLink>
      );
   };

   return (
      <div className={`candidate-sidebar-section ${section.wrapperClassName} pe-4`}>
         {!section.hideHeader && section.titleKey && (
            <div className={`SBHeader ${section.headerClassName || ''}`.trim()}>
               <h3 className={section.titleClassName}>{t(section.titleKey)}</h3>
               <hr />
            </div>
         )}
         <div className={`${section.desktopBodyClassName} candidate-sidebar-content open`}>
            {section.items.map(renderMenuItem)}
         </div>
      </div>
   );
};
